import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'energie cinetique (J)";
const DESCRIPTION =
  "Calculatrice d'energie cinetique (J). Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "kinetic energy calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/kinetic-energy-calculator/";
function KineticEnergyCalculator() {
  const [mass, setMass] = useState("");
  const [velocity, setVelocity] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!mass || !velocity) {
        setError("Veuillez entrer masse et vitesse");
        setResult(null);
        return;
      }
      const m = parseFloat(mass);
      const v = parseFloat(velocity);
      if (m <= 0) {
        setError("La masse doit être positive");
        setResult(null);
        return;
      }
      const ke = 0.5 * m * v * v;
      setResult(ke.toFixed(2));
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice d'énergie cinétique calcule l'énergie d'un objet en mouvement.
                  La formule est KE = 1/2 × m × v², où m est la masse en kg et v est la vitesse en m/s.
                </p>
                <ul>
                  <li>Calcul instantané</li>
                  <li>Utile pour les études de physique</li>
                  <li>Résultats en joules</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Masse (kg)
                      </label>
                      <input
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="Entrez la masse"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Vitesse (m/s)
                      </label>
                      <input
                        type="number"
                        value={velocity}
                        onChange={(e) => setVelocity(e.target.value)}
                        placeholder="Entrez la vitesse"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Énergie cinétique = <strong>{result} J</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>A quoi sert l'energie cinetique</h3></div>
              <div className="info-section-body">
                <p>L'energie cinetique represente l'energie liee au mouvement d'un corps. Elle est utilisee en mecanique, securite routiere, sport et ingenierie pour analyser l'effet d'une vitesse sur un objet.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Formule et interpretation</h3></div>
              <div className="info-section-body">
                <p>La formule est KE = 1/2 × m × v². La vitesse a un impact majeur car elle est au carre: si la vitesse double, l'energie cinetique est multipliee par quatre.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils de saisie</h3></div>
              <div className="info-section-body">
                <p>Saisissez la masse en kilogrammes et la vitesse en metres par seconde. Si vos donnees sont en km/h, convertissez-les avant le calcul pour obtenir un resultat correct en joules.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default KineticEnergyCalculator;
